import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-rate-config',
  templateUrl: './rate-config.component.html',
  styleUrls: ['./rate-config.component.scss']
})
export class AtwRateConfig implements OnInit {
  @Input() staticdata: any; // staticdata được truyền vào từ config
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() type: string; // xác định trang nào truyền đi : 'page' 'block_design' ' preview '
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // class được truyền vào
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  listIcon : any = [1,2,3,4,5]; // danh sách icon
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  // checkedRemoveShape: boolean = false;
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false
  };
  styles_field = [
    {
      title: 'nang_cao',
      index: 0,
    },
  ];
  // private textFormatDiffer: KeyValueDiffer<string, any>;
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    @Inject(PLATFORM_ID) private platformId: Object,
    private vhEventMediator: VhEventMediator,
  ) {}

  ngOnInit(): void {
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['shape']['width'] = event.width + 'px';
    if (event.height) this.class['shape']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /** Xác định kiểu hiển thị đánh giá
   * @param type : kiểu hiển thị => ví dụ: stars,emotions,hearts
   * @param index : vị trí kiểu
   */
  chooseType(type, index){
    if(this.device == 'desktop'){
      this.chooseTypeRateDevice(type, index);
    }
    else if(this.device == 'tablet_landscape'){
      this.chooseTypeRateDevice(type, index);
    }
    else if(this.device == 'tablet_portrait'){
      this.chooseTypeRateDevice(type, index);
    }
    else if(this.device == 'mobile_landscape'){
      this.chooseTypeRateDevice(type, index);
    }
    else{
      this.chooseTypeRateDevice(type, index);
    }
    this.updateObject();
  }

  /**
   * Hàm gọi và cập nhật type Icon Rate trong sản phẩm
   * @param typeIcon // kiểu hiển thị : star, emoji, hearts
   * @param index // vị trí hiển thị.
   */
  chooseTypeRateDevice(typeIcon, index){
    if (isPlatformBrowser(this.platformId)){
    let rate_template = document.querySelectorAll('.rate-template');
    this.staticdata[`${this.device}_format_rate`].rate_type = typeIcon;
    rate_template.forEach((item, key)=>{
      item.classList.remove('active');
      if(index == key){
        item.classList.add('active');
      }
    })}
  }

  // update trường mobile_portrait_hidden or desktop_hidden cho object
  updateHiiden(value) {
    this.vhQueryAutoWeb.updateObject(this.staticdata._id, value)
    .then((bool) => {
      
    }, error => {
      console.error(error)
    })
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  
  /**
   * Cập nhật các giá trị class trong json
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }

  /**
  * Cập nhật staticdata vào database.
  */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {

      });
  }

  /**
   * Cập nhật giá trị của object trong json.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }
}